<template>
  <div class="l-score-list">
    <p class="l-score-list-message">{{ result.msg }}</p>
    <h3>结果 {{ result.word }}</h3>
    <ul class="l-score-list-detail">
      <li v-for="(item) in formattedRecords" :key="item.originalId + '-' + item.subIndex">
        <span class="index">{{ item.displayKey }}.</span>
        <span>{{ item.word}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    element: {
      type: Object,
    },
    result: {
      type: Object,
    },
  },
  data() {
    return {
      pre: false,
    }
  },
  computed: {
    formattedRecords() {
      const records = this.element?.records || [];
      // 1. 按原始id分组，记录每个id对应的所有条目
      const groupByOriginalId = {};
      records.forEach(item => {
        if (!groupByOriginalId[item.eleId]) {
          groupByOriginalId[item.eleId] = [];
        }
        groupByOriginalId[item.eleId].push(item);
      });

      // 2. 生成最终格式化数据（重新编排序号）
      const formatted = [];
      let globalIndex = 1; // 全局展示主序号，从1开始
      
      // 遍历分组（保持原始数据顺序）
      Object.keys(groupByOriginalId).forEach(originalId => {
        const items = groupByOriginalId[originalId];
        const itemCount = items.length;

        // 为当前分组的每个条目生成展示key
        items.forEach((item, subIdx) => {
          const subIndex = subIdx + 1; // 子序号（1、2、3...）
          const displayKey = itemCount > 1 
            ? `${globalIndex}-${subIndex}` 
            : `${globalIndex}`;

          formatted.push({
            ...item,
            originalId: item.eleId, // 保留原始6位id
            globalIndex,         // 全局主序号
            subIndex,            // 子序号
            displayKey           // 最终展示的key
          });
        });

        // 只有当一个原始id的所有条目处理完，才递增全局主序号
        globalIndex++;
      });

      return formatted;
    }
  },
  methods: {
    onDetail() {
      this.pre = !this.pre
    },
  },
}
</script>

<style lang="stylus" scoped>
.l-score-list
  width 100%
  height 100%
  overflow auto
  .l-score-list-message
    display inline-block
    padding 0
    margin 0
    line-height 1.4
    &::after
      content ''
      display block
      margin 16px 0 0 0
      height 2px
      border-radius 100%
      background-color rgba(255, 255, 255, 0.2)
  h3
    margin 0
    padding 15px 0 10px 0
    font-size 19px
    font-weight 300
  .l-score-list-detail
    list-style none
    padding 0 0 5px 0
    margin 0
    display flex
    flex-wrap wrap
    li
      margin-bottom 5px
      flex 0 0 50%
      font-size 18px
      display flex
      align-items center
      .index
        display inline-block
        font-size 16px
        margin 0 5px 0 0
        text-align right
.my-sound
  margin-top 10px
</style>
